import styled from '@emotion/styled';

const MainStyle = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export default MainStyle;
